import { memo } from 'react';
import { NavLink } from 'react-router';
import clsx from 'clsx';

import { routesConfig } from '../../../../routes.config';

import styles from './styles/main-navigation.module.css';

export default memo(MainNavigation);

function MainNavigation() {
	return (
		<div className={clsx(styles['main-navigation'])}>
			<div className={clsx(styles['main-navigation__container'])}>
				<nav
					className={clsx(styles['main-navigation__nav'])}
					aria-label="Main"
				>
					<ul className={clsx(styles['main-navigation__list'])}>
						<li
							className={clsx(
								styles['main-navigation__li'],
								styles['main-navigation__logo'],
							)}
						>
							<NavLink
								className={clsx(
									styles['main-navigation__logo-link'],
								)}
								to={routesConfig.index.path}
							>
								<img
									src="/logo.svg"
									width="512"
									height="512"
									alt="Logotype"
									className={clsx(
										styles['main-navigation__logo-img'],
									)}
								/>
							</NavLink>
						</li>
						<li className={clsx(styles['main-navigation__li'])}>
							<NavLink
								className={({ isActive }) =>
									clsx(
										styles['main-navigation__nav-link'],
										isActive
											? styles[
													'main-navigation__nav-link--active'
												]
											: null,
									)
								}
								to={`/${routesConfig.howToCite.path}`}
							>
								How to cite
							</NavLink>
						</li>
						<li className={clsx(styles['main-navigation__li'])}>
							<NavLink
								className={({ isActive }) =>
									clsx(
										styles['main-navigation__nav-link'],
										isActive
											? styles[
													'main-navigation__nav-link--active'
												]
											: null,
									)
								}
								to={`/${routesConfig.propertyViewer.path}`}
							>
								Data
							</NavLink>
						</li>
						<li className={clsx(styles['main-navigation__li'])}>
							<NavLink
								className={({ isActive }) =>
									clsx(
										styles['main-navigation__nav-link'],
										isActive
											? styles[
													'main-navigation__nav-link--active'
												]
											: null,
									)
								}
								to={`/${routesConfig.propertyCalculator.path}`}
							>
								Predictions
							</NavLink>
						</li>
					</ul>
				</nav>
			</div>
		</div>
	);
}
